const config = {
  reactAppUrl: process.env.REACT_APP_URL,
  HEART_BEAT_INTERVAL:parseInt(process.env.REACT_APP_HEART_BEAT_INTERVAL || "40000")
};
export default config